import 'public/style.scss'
import 'public/main'
import Rails from "@rails/ujs"
Rails.start();

window.jQuery = $;
window.$ = $;
